export enum promotionMicrocopy {
  PROMO_4 = 'PROMO_4',
  PROMO_4_BANNER = 'PROMO_4_BANNER',
}
